import { Badge, Icons } from '@commenda/kakashi';
import { TWorkflowExecution } from '@commenda/types';
import {
  calculateStepGroupExpectedSLAMs,
  formatDuration,
} from '@commenda/utils';
import { useMemo } from 'react';

type TServiceRequestStepSLABadgeProps = {
  workflowDefinitionStepGroupId?: string | null;
  workflowExecution?: TWorkflowExecution;
};

export const ServiceRequestStepSLABadge = ({
  workflowDefinitionStepGroupId,
  workflowExecution,
}: TServiceRequestStepSLABadgeProps) => {
  const expectedSLAMs = useMemo(() => {
    const definition = workflowExecution?.WorkflowTemplateVersion?.definition;
    if (!definition || !workflowDefinitionStepGroupId) return 0;
    return calculateStepGroupExpectedSLAMs(
      definition,
      workflowDefinitionStepGroupId
    );
  }, [workflowExecution, workflowDefinitionStepGroupId]);

  if (expectedSLAMs <= 0) return null;

  return (
    <Badge
      variant="gray"
      size="sm"
      iconLeading={<Icons.Clock className="size-3" />}
    >
      {formatDuration(expectedSLAMs)}
    </Badge>
  );
};
